import { useState } from "react";
import { ERROR_MESSAGES, ITEMS_PER_PAGE } from "../../../constant/constant";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { useAxios } from "../../../utils/useAxios";

export const useGetLightParents = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { axiosInstance } = useAxios();

  const [parents, setParents] = useState(undefined);
  const [metaData, setMetaData] = useState(undefined);

  /**
   * Fetch parents with pagination
   */
  const getParents = async ({
    page = 1,
    per_page = ITEMS_PER_PAGE,
    paginate = true,
    filters = {},
    sort = "",
  } = {}) => {
    setLoading(true);
    setError("");

    try {
      const query = new URLSearchParams();

      query.append("page", page.toString());
      query.append("per_page", per_page.toString());
      query.append("paginate", paginate);

      Object.keys(filters).forEach((field) => {
        if (filters[field] !== "" && filters[field] !== undefined) {
          query.append(`filter[${field}]`, filters[field]);
        }
      });

      if (sort) query.append("sort", sort);

      const url = `${TENANT_DOMAIN}/references/students?${query.toString()}`;
      const response = await axiosInstance.get(url);

      const data = response.data.data || [];
      const meta = response.data.meta || null;

      setParents((prev) => {
        if (page === 1 || !prev) {
          return data;
        }
        return [...prev, ...data];
      });

      setMetaData(meta);

      /* ✅ IMPORTANT: return response for infinite scroll */
      return {
        success: true,
        data,
        meta,
      };
    } catch (err) {
      const errorMessage =
        err?.response?.status === 500
          ? ERROR_MESSAGES.INTERNAL_SERVER
          : err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN;

      setParents(null);
      setMetaData(null);
      setError(errorMessage);

      return {
        success: false,
        data: [],
        meta: null,
        error: errorMessage,
      };
    } finally {
      setLoading(false);
    }
  };

  return { loading, error, parents, getParents, metaData };
};
